import "./errorText.scss";

const ErrorText = (props: any) => {
  const { error,TextYellow } = props;
  return <div className={`error__text ${TextYellow ? "yellowish__color":""}`}>{error}</div>;
};

export default ErrorText;
